// screeners/actionCreators.js

import actionTypes from './actionTypes';

const requestScreenerAccess = () => ({
    type: actionTypes.REQUEST_SCREENER_ACCESS,
});

const screenerAccessResponse = (success, errors) => ({
    type: actionTypes.SCREENER_ACCESS_RESPONSE,
    payload: {
        success,
        errors,
    }
});

export default {
    requestScreenerAccess,
    screenerAccessResponse
};
